module.exports = __webpack_public_path__ + "img/awards_image_19.961b6636.jpg";